import { Helmet } from "react-helmet-async";

// Restaurant-menu-only font load. Without this, the menu flow's CSS asks
// for "Inter" (see --font-sans in styles/tokens.css) but nothing ever
// loads it, so the browser silently falls back through
// -apple-system/Segoe UI/Roboto/Arial depending on the visitor's device —
// most letters look fine, but the fallback stack doesn't consistently
// carry a matching glyph for the rarer Hungarian double-acute characters
// (ő/ű), so those specific letters can render in a visually mismatched
// substitute font. Loading Inter directly (Google's default subset
// includes Latin Extended-A, which covers ő/ű) fixes that at the source.
// Kept separate from MarketingFonts.js (Fraunces + JetBrains Mono aren't
// used anywhere in the ordering flow) so guests don't pay for fonts the
// menu never renders.
function MenuFonts() {
  return (
    <Helmet>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
      <link
        href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap"
        rel="stylesheet"
      />
    </Helmet>
  );
}

export default MenuFonts;
